//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class EmailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEmail(ensUserTid: number): Promise<string> {
        let url_ = this.baseUrl + "/Email/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmail(_response);
        });
    }

    protected processGetEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHealth(): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthStatus>(null as any);
    }
}

export class OrgChartClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getOrgChart(): Promise<EmployeeInfo[]> {
        let url_ = this.baseUrl + "/OrgChart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrgChart(_response);
        });
    }

    protected processGetOrgChart(response: Response): Promise<EmployeeInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeInfo[]>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsers(agentOnly: boolean | null | undefined, includeInactive: boolean | null | undefined): Promise<UserBasicInfo[]> {
        let url_ = this.baseUrl + "/User?";
        if (agentOnly !== undefined && agentOnly !== null)
            url_ += "agentOnly=" + encodeURIComponent("" + agentOnly) + "&";
        if (includeInactive !== undefined && includeInactive !== null)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<UserBasicInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserBasicInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBasicInfo[]>(null as any);
    }

    getEnsUserInfos(agentOnly: boolean | null | undefined, includeInactive: boolean | null | undefined): Promise<EnsUserInfo[]> {
        let url_ = this.baseUrl + "/User/detailed?";
        if (agentOnly !== undefined && agentOnly !== null)
            url_ += "agentOnly=" + encodeURIComponent("" + agentOnly) + "&";
        if (includeInactive !== undefined && includeInactive !== null)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEnsUserInfos(_response);
        });
    }

    protected processGetEnsUserInfos(response: Response): Promise<EnsUserInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsUserInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsUserInfo[]>(null as any);
    }

    getEnsUserInfo(ensUserTid: number): Promise<EnsUserInfo> {
        let url_ = this.baseUrl + "/User/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEnsUserInfo(_response);
        });
    }

    protected processGetEnsUserInfo(response: Response): Promise<EnsUserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsUserInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsUserInfo>(null as any);
    }

    patchEnsUserInfo(ensUserTid: number, req: EnsUserInfoPatchReq): Promise<EnsUserInfo> {
        let url_ = this.baseUrl + "/User/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchEnsUserInfo(_response);
        });
    }

    protected processPatchEnsUserInfo(response: Response): Promise<EnsUserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsUserInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsUserInfo>(null as any);
    }
}

export class UserInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBasicInfo(ensUserTid: number | null | undefined, userEmail: string | null | undefined): Promise<UserBasicInfo> {
        let url_ = this.baseUrl + "/UserInfo/basic?";
        if (ensUserTid !== undefined && ensUserTid !== null)
            url_ += "ensUserTid=" + encodeURIComponent("" + ensUserTid) + "&";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBasicInfo(_response);
        });
    }

    protected processGetBasicInfo(response: Response): Promise<UserBasicInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserBasicInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserBasicInfo>(null as any);
    }
}

export class UserRelationshipClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUploadUrl(): Promise<PreSignedUrlResponse> {
        let url_ = this.baseUrl + "/UserRelationship/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadUrl(_response);
        });
    }

    protected processGetUploadUrl(response: Response): Promise<PreSignedUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreSignedUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSignedUrlResponse>(null as any);
    }

    processReport(guid: string): Promise<EmployeeRelationshipReportJob> {
        let url_ = this.baseUrl + "/UserRelationship/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessReport(_response);
        });
    }

    protected processProcessReport(response: Response): Promise<EmployeeRelationshipReportJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeRelationshipReportJob.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeRelationshipReportJob>(null as any);
    }

    getLatest(): Promise<EmployeeRelationshipJobStatus[]> {
        let url_ = this.baseUrl + "/UserRelationship/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatest(_response);
        });
    }

    protected processGetLatest(response: Response): Promise<EmployeeRelationshipJobStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeRelationshipJobStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeRelationshipJobStatus[]>(null as any);
    }
}

export class TimesheetClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUploadUrl(): Promise<PreSignedUrlResponse> {
        let url_ = this.baseUrl + "/Timesheet";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadUrl(_response);
        });
    }

    protected processGetUploadUrl(response: Response): Promise<PreSignedUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreSignedUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSignedUrlResponse>(null as any);
    }

    processTimesheet(guid: string): Promise<TimesheetJob> {
        let url_ = this.baseUrl + "/Timesheet/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessTimesheet(_response);
        });
    }

    protected processProcessTimesheet(response: Response): Promise<TimesheetJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetJob.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetJob>(null as any);
    }

    getLatest(): Promise<TimesheetJobStatus[]> {
        let url_ = this.baseUrl + "/Timesheet/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatest(_response);
        });
    }

    protected processGetLatest(response: Response): Promise<TimesheetJobStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimesheetJobStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetJobStatus[]>(null as any);
    }
}

export class PermissionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPermissionsList(): Promise<UserPermission[]> {
        let url_ = this.baseUrl + "/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPermissionsList(_response);
        });
    }

    protected processGetPermissionsList(response: Response): Promise<UserPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermission.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPermission[]>(null as any);
    }

    getPermissions(ensUserTid: number): Promise<UserPermission[]> {
        let url_ = this.baseUrl + "/Permissions/user/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: Response): Promise<UserPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermission.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPermission[]>(null as any);
    }

    setPermissions(ensUserTid: number, permissions: EnsUserPermissionType[]): Promise<UserPermission[]> {
        let url_ = this.baseUrl + "/Permissions/user/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPermissions(_response);
        });
    }

    protected processSetPermissions(response: Response): Promise<UserPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermission.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPermission[]>(null as any);
    }
}

export class RolesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRolesList(): Promise<UserRole[]> {
        let url_ = this.baseUrl + "/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRolesList(_response);
        });
    }

    protected processGetRolesList(response: Response): Promise<UserRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRole[]>(null as any);
    }

    getRoles(ensUserTid: number): Promise<UserRole[]> {
        let url_ = this.baseUrl + "/Roles/user/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<UserRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRole[]>(null as any);
    }

    setRole(ensUserTid: number, ensUserRoleType: EnsUserRoleType): Promise<UserRole> {
        let url_ = this.baseUrl + "/Roles/user/{ensUserTid}/{ensUserRoleType}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        if (ensUserRoleType === undefined || ensUserRoleType === null)
            throw new Error("The parameter 'ensUserRoleType' must be defined.");
        url_ = url_.replace("{ensUserRoleType}", encodeURIComponent("" + ensUserRoleType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRole(_response);
        });
    }

    protected processSetRole(response: Response): Promise<UserRole> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRole.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRole>(null as any);
    }

    getRolePermissions(ensUserRoleType: EnsUserRoleType): Promise<UserPermission[]> {
        let url_ = this.baseUrl + "/Roles/{ensUserRoleType}";
        if (ensUserRoleType === undefined || ensUserRoleType === null)
            throw new Error("The parameter 'ensUserRoleType' must be defined.");
        url_ = url_.replace("{ensUserRoleType}", encodeURIComponent("" + ensUserRoleType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRolePermissions(_response);
        });
    }

    protected processGetRolePermissions(response: Response): Promise<UserPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermission.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPermission[]>(null as any);
    }

    setRolePermissions(ensUserRoleType: EnsUserRoleType, permissions: EnsUserPermissionType[]): Promise<UserPermission[]> {
        let url_ = this.baseUrl + "/Roles/{ensUserRoleType}";
        if (ensUserRoleType === undefined || ensUserRoleType === null)
            throw new Error("The parameter 'ensUserRoleType' must be defined.");
        url_ = url_.replace("{ensUserRoleType}", encodeURIComponent("" + ensUserRoleType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRolePermissions(_response);
        });
    }

    protected processSetRolePermissions(response: Response): Promise<UserPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermission.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPermission[]>(null as any);
    }
}

export class HealthStatus implements IHealthStatus {
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildEnvironment = _data["buildEnvironment"];
            this.database = _data["database"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildEnvironment"] = this.buildEnvironment;
        data["database"] = this.database;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthStatus {
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;
}

export class EmployeeInfo implements IEmployeeInfo {
    name?: string | undefined;
    userTid?: number;
    managerName?: string | undefined;
    managerUserTid?: number;
    title?: string | undefined;
    department?: string | undefined;
    colorCode?: string | undefined;

    constructor(data?: IEmployeeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userTid = _data["userTid"];
            this.managerName = _data["managerName"];
            this.managerUserTid = _data["managerUserTid"];
            this.title = _data["title"];
            this.department = _data["department"];
            this.colorCode = _data["colorCode"];
        }
    }

    static fromJS(data: any): EmployeeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userTid"] = this.userTid;
        data["managerName"] = this.managerName;
        data["managerUserTid"] = this.managerUserTid;
        data["title"] = this.title;
        data["department"] = this.department;
        data["colorCode"] = this.colorCode;
        return data;
    }
}

export interface IEmployeeInfo {
    name?: string | undefined;
    userTid?: number;
    managerName?: string | undefined;
    managerUserTid?: number;
    title?: string | undefined;
    department?: string | undefined;
    colorCode?: string | undefined;
}

export class UserBasicInfo implements IUserBasicInfo {
    ensUserTid!: number;
    userEmail!: string;
    roles!: UserRole[];
    permissions!: UserPermission[];

    constructor(data?: IUserBasicInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserTid = _data["ensUserTid"];
            this.userEmail = _data["userEmail"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserBasicInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserBasicInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserTid"] = this.ensUserTid;
        data["userEmail"] = this.userEmail;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserBasicInfo {
    ensUserTid: number;
    userEmail: string;
    roles: UserRole[];
    permissions: UserPermission[];
}

export class UserRole implements IUserRole {
    ensUserRoleType!: EnsUserRoleType;
    ensUserRoleName!: string;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserRoleType = _data["ensUserRoleType"];
            this.ensUserRoleName = _data["ensUserRoleName"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserRoleType"] = this.ensUserRoleType;
        data["ensUserRoleName"] = this.ensUserRoleName;
        return data;
    }
}

export interface IUserRole {
    ensUserRoleType: EnsUserRoleType;
    ensUserRoleName: string;
}

export enum EnsUserRoleType {
    ContactCenterAgent = 1,
    ContactCenterSupervisor = 2,
    FinanceSupervisor = 3,
    IapOwner = 4,
    ComplianceSupervisor = 5,
}

export class UserPermission implements IUserPermission {
    ensUserPermissionType!: EnsUserPermissionType;
    ensUserPermissionName!: string;
    isRolePermission!: boolean;

    constructor(data?: IUserPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserPermissionType = _data["ensUserPermissionType"];
            this.ensUserPermissionName = _data["ensUserPermissionName"];
            this.isRolePermission = _data["isRolePermission"];
        }
    }

    static fromJS(data: any): UserPermission {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserPermissionType"] = this.ensUserPermissionType;
        data["ensUserPermissionName"] = this.ensUserPermissionName;
        data["isRolePermission"] = this.isRolePermission;
        return data;
    }
}

export interface IUserPermission {
    ensUserPermissionType: EnsUserPermissionType;
    ensUserPermissionName: string;
    isRolePermission: boolean;
}

export enum EnsUserPermissionType {
    AdminAccess = 1,
    OperationsAccess = 2,
    SalesAccess = 3,
    DataAccess = 4,
    EnterSale = 5,
    ModifySaleAll = 6,
    ModifySaleNotesOnly = 7,
    AdminEmployeePermissions = 8,
    CronBossAccess = 9,
    ReadCallLogs = 10,
    OrganizationChartAccess = 11,
    TimesheetUploadAccess = 12,
    EmployeeRelationshipUploadAccess = 13,
    CallAudioAccess = 14,
    SalesAdminAccess = 15,
    CallAnalyticsAccess = 16,
    LicensingAccess = 17,
    LicensingEditAccess = 18,
    OperationsAdminAccess = 19,
}

export class EnsUserInfo implements IEnsUserInfo {
    ensUserTid!: number;
    userName?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userEmail?: string | undefined;
    active?: boolean | undefined;
    ssn?: string | undefined;
    ssnLastFour?: string | undefined;
    dobUnix?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personalEmail?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hireDateUnix?: number | undefined;
    terminationDateUnix?: number | undefined;
    npn?: string | undefined;
    reportsTo?: string | undefined;

    constructor(data?: IEnsUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserTid = _data["ensUserTid"];
            this.userName = _data["userName"];
            this.userFirstName = _data["userFirstName"];
            this.userLastName = _data["userLastName"];
            this.userEmail = _data["userEmail"];
            this.active = _data["active"];
            this.ssn = _data["ssn"];
            this.ssnLastFour = _data["ssnLastFour"];
            this.dobUnix = _data["dobUnix"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.personalEmail = _data["personalEmail"];
            this.phone = _data["phone"];
            this.phoneExtension = _data["phoneExtension"];
            this.hireDateUnix = _data["hireDateUnix"];
            this.terminationDateUnix = _data["terminationDateUnix"];
            this.npn = _data["npn"];
            this.reportsTo = _data["reportsTo"];
        }
    }

    static fromJS(data: any): EnsUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EnsUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserTid"] = this.ensUserTid;
        data["userName"] = this.userName;
        data["userFirstName"] = this.userFirstName;
        data["userLastName"] = this.userLastName;
        data["userEmail"] = this.userEmail;
        data["active"] = this.active;
        data["ssn"] = this.ssn;
        data["ssnLastFour"] = this.ssnLastFour;
        data["dobUnix"] = this.dobUnix;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["personalEmail"] = this.personalEmail;
        data["phone"] = this.phone;
        data["phoneExtension"] = this.phoneExtension;
        data["hireDateUnix"] = this.hireDateUnix;
        data["terminationDateUnix"] = this.terminationDateUnix;
        data["npn"] = this.npn;
        data["reportsTo"] = this.reportsTo;
        return data;
    }
}

export interface IEnsUserInfo {
    ensUserTid: number;
    userName?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userEmail?: string | undefined;
    active?: boolean | undefined;
    ssn?: string | undefined;
    ssnLastFour?: string | undefined;
    dobUnix?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personalEmail?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hireDateUnix?: number | undefined;
    terminationDateUnix?: number | undefined;
    npn?: string | undefined;
    reportsTo?: string | undefined;
}

export class EnsUserInfoPatchReq implements IEnsUserInfoPatchReq {
    userName?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userEmail?: string | undefined;
    active?: boolean | undefined;
    ssn?: string | undefined;
    ssnLastFour?: string | undefined;
    dobUnix?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personalEmail?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hireDateUnix?: number | undefined;
    terminationDateUnix?: number | undefined;
    npn?: string | undefined;

    constructor(data?: IEnsUserInfoPatchReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userFirstName = _data["userFirstName"];
            this.userLastName = _data["userLastName"];
            this.userEmail = _data["userEmail"];
            this.active = _data["active"];
            this.ssn = _data["ssn"];
            this.ssnLastFour = _data["ssnLastFour"];
            this.dobUnix = _data["dobUnix"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.personalEmail = _data["personalEmail"];
            this.phone = _data["phone"];
            this.phoneExtension = _data["phoneExtension"];
            this.hireDateUnix = _data["hireDateUnix"];
            this.terminationDateUnix = _data["terminationDateUnix"];
            this.npn = _data["npn"];
        }
    }

    static fromJS(data: any): EnsUserInfoPatchReq {
        data = typeof data === 'object' ? data : {};
        let result = new EnsUserInfoPatchReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userFirstName"] = this.userFirstName;
        data["userLastName"] = this.userLastName;
        data["userEmail"] = this.userEmail;
        data["active"] = this.active;
        data["ssn"] = this.ssn;
        data["ssnLastFour"] = this.ssnLastFour;
        data["dobUnix"] = this.dobUnix;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["personalEmail"] = this.personalEmail;
        data["phone"] = this.phone;
        data["phoneExtension"] = this.phoneExtension;
        data["hireDateUnix"] = this.hireDateUnix;
        data["terminationDateUnix"] = this.terminationDateUnix;
        data["npn"] = this.npn;
        return data;
    }
}

export interface IEnsUserInfoPatchReq {
    userName?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userEmail?: string | undefined;
    active?: boolean | undefined;
    ssn?: string | undefined;
    ssnLastFour?: string | undefined;
    dobUnix?: number | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personalEmail?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hireDateUnix?: number | undefined;
    terminationDateUnix?: number | undefined;
    npn?: string | undefined;
}

export class PreSignedUrlResponse implements IPreSignedUrlResponse {
    presignedUrl!: string;
    objectPrefix!: string | undefined;
    objectGuid!: string;

    constructor(data?: IPreSignedUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presignedUrl = _data["presignedUrl"];
            this.objectPrefix = _data["objectPrefix"];
            this.objectGuid = _data["objectGuid"];
        }
    }

    static fromJS(data: any): PreSignedUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreSignedUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presignedUrl"] = this.presignedUrl;
        data["objectPrefix"] = this.objectPrefix;
        data["objectGuid"] = this.objectGuid;
        return data;
    }
}

export interface IPreSignedUrlResponse {
    presignedUrl: string;
    objectPrefix: string | undefined;
    objectGuid: string;
}

export class EmployeeRelationshipReportJob implements IEmployeeRelationshipReportJob {
    guid!: string;

    constructor(data?: IEmployeeRelationshipReportJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): EmployeeRelationshipReportJob {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRelationshipReportJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface IEmployeeRelationshipReportJob {
    guid: string;
}

export class EmployeeRelationshipJobStatus implements IEmployeeRelationshipJobStatus {
    guid!: string;
    lastEventDatetime!: Date;
    state!: CronTaskStateType;

    constructor(data?: IEmployeeRelationshipJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.lastEventDatetime = _data["lastEventDatetime"] ? new Date(_data["lastEventDatetime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): EmployeeRelationshipJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRelationshipJobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["lastEventDatetime"] = this.lastEventDatetime ? this.lastEventDatetime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IEmployeeRelationshipJobStatus {
    guid: string;
    lastEventDatetime: Date;
    state: CronTaskStateType;
}

export enum CronTaskStateType {
    Provisioning = 0,
    Running = 1,
    Success = 2,
    Failure = 3,
}

export class TimesheetJob implements ITimesheetJob {
    guid!: string;

    constructor(data?: ITimesheetJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): TimesheetJob {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface ITimesheetJob {
    guid: string;
}

export class TimesheetJobStatus implements ITimesheetJobStatus {
    guid!: string;
    lastEventDatetime!: Date;
    state!: CronTaskStateType;

    constructor(data?: ITimesheetJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.lastEventDatetime = _data["lastEventDatetime"] ? new Date(_data["lastEventDatetime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): TimesheetJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetJobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["lastEventDatetime"] = this.lastEventDatetime ? this.lastEventDatetime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface ITimesheetJobStatus {
    guid: string;
    lastEventDatetime: Date;
    state: CronTaskStateType;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}